<template>
    <component :is="component" :paginationData="paginationData"  :listLength="listLength" v-if="component" :type="type"/>
</template>

<script>
import {defineAsyncComponent} from "vue";

export default {
    name: "PaginationLink",
    mixins: [],
    components: {},
    provide() {
        return {}
    },
    props: {
        paginationLayout: {

        },
        paginationData: {default: () => {return {total: 0, page: 0, size: 0,}}
        },
        listLength: {
            type: Number,
            default: 0
        },
        type: {},

    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        // this.templateLoader();

    },
    beforeUnmount() {},
    unmounted() {},
    computed: {
        component() {
            if (!this.paginationLayout) {
                return defineAsyncComponent(() => import('@/components/alarm/layout/pagination/PaginationDefaultLayout.vue'))
            }
            return defineAsyncComponent(() => import(`@/components/alarm/layout/pagination/${this.paginationLayout}.vue`))
        },
    },
    methods: {
    },
    watch: {},
}
</script>

<style scoped>

</style>
